module.exports = __webpack_public_path__ + "static/OP6-9cd821f2d938c8e987683e8a581c9886.png";